// removed by extract-text-webpack-plugin
module.exports = {"heading":"src-components-modules-Quote-style----general-module---heading---243Zz","caption":"src-components-modules-Quote-style----general-module---caption---3iape marginTop-s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Quote/style/general.module.css
// module id = 259
// module chunks = 33019919093843 96834539877599 171778037205648